"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Text = exports.Arrow = exports.Node = exports.Round = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  &:not(:first-child){\n    display: flex;\n    position: relative ;\n    padding:", " 0 0 0;\n    margin: 0;\n  }\n  &:empty::before {\n    border-left : none !important;\n  }\n  &:not(:first-child)::before{\n    content: '';\n    position: absolute;\n    top: 0;\n    left: calc( 50% - ", ");\n    border-left: ", " solid ", ";\n    width: 0;\n    height: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-family: 'Open Sans', sans-serif;\n  color: '#fff';\n  font-size: 15px;\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border: solid  ", " ;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  left: calc( 50% - 4px );\n  margin-top: -7px;\n  position: absolute;\n\n  transform: rotate(45deg);\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  text-align: center;\n  list-style-type: none;\n  position: relative;\n  padding: ", " 5px 0 5px ;\n  ::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right:  calc( 50% - ", ");\n    border-top: ", " solid ", " ;\n    width: 50%;\n    height: ", ";\n    z-index: -1;\n  }\n  ::after{\n    left: calc( 50% - ", ");\n    border-left: ", " solid ", ";\n    content: '';\n    position: absolute;\n    top: 0;\n    //right: calc( 50% - ", ");\n    border-top: ", " solid ", ";\n    width: 50%;\n    height: ", ";\n    z-index: -1;\n  }\n  &:first-child::before{\n    border: 0 none;\n  }\n  &:last-child::after{\n  border : none \n  }\n&:last-child::before{\n  border-right: ", " solid ", ";\n}\n&:only-child{\n  padding-top : 0px;\n  margin: auto auto \n}\n&:only-child::before {\n  border-right : none ;\n  left : 0px;\n  right : 0px ;\n}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  border: 2px solid  ", ";\n  background-color: #fff;\n  left: calc( 50% - 5px );\n  top: -3px;\n  border-radius: 3px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  z-index: 135;\n  margin-top: 2px;\n  padding: 10px 20px;\n  color: white;\n  border-radius: 8px;\n  background-color: #1890ff;\n  box-shadow: 0 2px 0 rgba(0,0,0,0.045);\n  &:hover{ \n    cursor: pointer;\n  }\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents.default.div(_templateObject(), function (props) {
  return props.styles ? _objectSpread({}, props.styles) : '';
});

exports.Wrapper = Wrapper;

var Round = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.color || '#d6e2ea';
});

exports.Round = Round;

var Node = _styledComponents.default.li(_templateObject3(), function (props) {
  return props.styles ? props.styles.height : '40px';
}, function (props) {
  return (0, _utils.calcWidth)(props.styles.width);
}, function (props) {
  return props.styles.width || '2px';
}, function (props) {
  return props.styles.color || '#d6e2ea';
}, function (props) {
  return props.styles ? props.styles.height : '40px';
}, function (props) {
  return (0, _utils.calcWidth)(props.styles.width);
}, function (props) {
  return props.styles.width || '2px';
}, function (props) {
  return props.styles.color || '#d6e2ea';
}, function (props) {
  return (0, _utils.calcWidth)(props.styles.width);
}, function (props) {
  return props.styles.width || '2px';
}, function (props) {
  return props.styles.color || '#d6e2ea';
}, function (props) {
  return props.styles ? props.styles.height : '40px';
}, function (props) {
  return props.styles.width || '2px';
}, function (props) {
  return props.styles.color || '#d6e2ea';
});

exports.Node = Node;

var Arrow = _styledComponents.default.span(_templateObject4(), function (props) {
  return props.color ? props.color : '#d6e2ea';
});

exports.Arrow = Arrow;

var Text = _styledComponents.default.span(_templateObject5(), function (props) {
  return props.styles ? _objectSpread({}, props.styles) : '';
});

exports.Text = Text;

var Root = _styledComponents.default.ul(_templateObject6(), function (props) {
  return props.styles.height;
}, function (props) {
  return (0, _utils.calcWidth)(props.styles.width);
}, function (props) {
  return props.styles.width || '2px';
}, function (props) {
  return props.styles.color || '#d6e2ea';
}, function (props) {
  return props.styles.height || '40px';
});

exports.Root = Root;